var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolandFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H0V14.9997H22.5V0Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H0V7.49984H22.5V0Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolandFlag);
export default __webpack_public_path__ + "static/media/poland-flag.c30b09defef3a8ff3010a9bf73550377.svg";
export { ForwardRef as ReactComponent };